// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[dir] .chart-container[data-v-22b36c96] {\r\n  padding: 1rem;\n}\n.ticket-category-status[data-v-22b36c96] {\r\n  min-height: 450px;\n}\r\n", ""]);
// Exports
module.exports = exports;
